import React from 'react';

import classes from './ExpertSectionHeading.module.scss';

const ExpertSectionHeading = ({ icon, children }) => {
	return (
		<h2 className={classes['heading']}>
			<span className={classes['icon']}>{icon}</span>
			{children}
		</h2>
	);
};

export default ExpertSectionHeading;
